import React from 'react';

import { Box, Flex } from '@rover/kibble/core';
import LoadingShimmer from '@rover/kibble/patterns/LoadingShimmer';

const RevampServicesCtaLoadingShimmer = (): JSX.Element => (
  <Box data-testid="revamp-services-cta-loading" p="6x">
    <Flex flexDirection="column" gap="4x">
      {/* Service dropdown shimmer */}
      <LoadingShimmer width="100%" height={48} margin="0x" />
      {/* Price shimmer */}
      <LoadingShimmer width={160} height={28} margin="0x" />
      {/* See all rates link shimmer */}
      <LoadingShimmer width={100} height={18} margin="0x" />
      {/* Contact button shimmer */}
      <LoadingShimmer width="100%" height={48} margin="0x" />
      {/* Cancellation policy shimmer */}
      <LoadingShimmer width="80%" height={16} margin="0x" />
    </Flex>
  </Box>
);

export default RevampServicesCtaLoadingShimmer;
